import { render, staticRenderFns } from "./groups.vue?vue&type=template&id=7d3b7bd0&"
import script from "./groups.vue?vue&type=script&lang=js&"
export * from "./groups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d3b7bd0')) {
      api.createRecord('7d3b7bd0', component.options)
    } else {
      api.reload('7d3b7bd0', component.options)
    }
    module.hot.accept("./groups.vue?vue&type=template&id=7d3b7bd0&", function () {
      api.rerender('7d3b7bd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/shared/user/modal/tabs/groups.vue"
export default component.exports